import { CalendarIcon, ClockIcon, HomeIcon } from '@heroicons/react/outline'
import { useMemo } from 'react'

import { ICourse, IKDTKlass } from '../../stores/courses'
import { getCourseTotalTime } from '../../utils/sec2time'
import { IApplyPeriodList } from '.'

interface IKlassInfoSectionProps {
  course: ICourse | IKDTKlass
  isKDT: boolean
  isSimplifyKDT: boolean
  isDelayCourse?: boolean
  isPreNoticeStatus?: boolean
  applyStatus: string
  applyPeriodList?: IApplyPeriodList
}

interface IDetailKlassInfo {
  icon: React.ReactNode
  title: string
  content: string
}
const KlassInfoSection = ({
  course,
  isKDT,
  isSimplifyKDT,
  isDelayCourse,
  isPreNoticeStatus,
  applyStatus,
  applyPeriodList,
}: IKlassInfoSectionProps) => {
  const {
    weeks,
    startedAt,
    endedAt,
    totalResources,
    totalSeconds,
    isOffline,
    level,
    flags,
    courseType,
  } = course
  const isStartUp = useMemo(() => courseType === 'kdt_startup', [courseType])
  const courseWeek = useMemo(() => {
    return weeks ? (weeks >= 52 ? '1년' : `${weeks}주`) : ''
  }, [weeks])

  const getEduType = (klassType: string) => {
    if (klassType === 'kdt' || klassType === 'kdt_plus' || klassType === 'kdt_startup') {
      if (flags.includes('onoffline')) {
        return '온라인 / 오프라인'
      }

      if (flags.includes('online')) {
        return '온라인'
      }

      if (flags.includes('offline')) {
        return '오프라인'
      }
    } else {
      return isOffline ? '오프라인' : '온라인 VOD'
    }

    return '온라인'
  }

  const detailInfoList = useMemo(
    () => [
      {
        icon: <ClockIcon className="h-5 w-5" />,
        title: isKDT ? '강의분량' : '수업분량',
        content:
          isKDT && totalSeconds
            ? `${getCourseTotalTime(totalSeconds)} (약 ${isStartUp ? '7' : '8'}시간/일)`
            : totalResources && totalSeconds && totalResources > 0 && totalSeconds > 0
            ? `총 ${totalResources}개 수업${
                isDelayCourse ? '' : ` ∙ ${getCourseTotalTime(totalSeconds)}`
              }`
            : '',
      },
      {
        icon: <HomeIcon className="h-5 w-5" />,
        title: '수강방식',
        content: getEduType(courseType),
      },
      {
        icon: <CalendarIcon className="h-5 w-5" />,
        title: '수강기간',
        content: endedAt?.includes('9998')
          ? '평생 소장'
          : `${courseWeek}${isDelayCourse ? ' ∙ 영상 순차 공개' : ''}`,
      },
    ],
    [course, isKDT],
  )
  console.log(detailInfoList)

  const renderKlassDetailInfoList = (infoList: IDetailKlassInfo[]) =>
    infoList.map(({ icon, title, content }, idx) => (
      <li
        key={`${title}_${idx}`}
        className={`flex items-center text-sm ${
          isKDT && idx === 3 && ['ing', 'end'].includes(applyStatus) ? 'hidden' : ''
        }`}>
        <span className="inline-flex items-center">
          <span>{icon}</span>
          <span className="ml-2 min-w-12.5 font-semibold">{title}</span>
        </span>
        <span className="ml-2 whitespace-nowrap">{content}</span>
      </li>
    ))

  return <ul className="flex flex-col space-y-3">{renderKlassDetailInfoList(detailInfoList)}</ul>
}

export default KlassInfoSection
